module.exports = __webpack_public_path__ + "static/img/KUKA.df8220b6.png";